import { ReactNode } from 'react';
import { Card, withStyles } from 'vopay';
import { Title, DetailsRows } from 'UI';
import type { DetailsRowItem } from '../DetailsRows/DetailsRows';
import styles from './TransactionDetailsCard.module.scss';

type TransactionDetailsCardProps = {
  title: ReactNode;
  details: DetailsRowItem[];
};

const cn = withStyles(styles);

export default function TransactionDetailsCard({ title, details }: TransactionDetailsCardProps) {
  return (
    <Card className={cn('card')}>
      <Title level="4" className={cn('title')}>
        {title}
      </Title>

      <DetailsRows details={details} />
    </Card>
  );
}
